import axios, { AxiosHeaders, InternalAxiosRequestConfig } from 'axios';
import { apiBaseUrl } from '@utils';
import cookiesService from '../cookies';

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  withCredentials: true,
});

apiClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const deviceId = cookiesService.getOrCreateDeviceId();

  const headers = AxiosHeaders.from(config.headers);
  headers.set('device-id', deviceId);

  return {
    ...config,
    headers,
  };
});

export const graphqlApi = async (query: string, variables?: object) =>
  apiClient.post('', { query, variables });
